import {
    SET_CATEGORY,
   
} from './constants';

const initState = {
    category: '',
};

function reduce(state, action) {
    switch (action.type) {
        case SET_CATEGORY:
            return {
                ...state,
                category: action.payload,
               
            };
        default:
            break;
    }
}

export { initState };
export default reduce;
